/* eslint-disable */
import {
  RACButton,
  RACTable,
  RACTableCell,
  RACTableRow,
  RACTooltip,
  Typography,
} from '@rentacenter/racstrap';
import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next'; // Import i18next
import { useCustomerDetails } from '../../../context/CustomerDetails/CustomerDetailsProvider';
import { StoreStateContext, useStoreDetails } from '../../../context/Store/StoreProvider';
import { CustomerLocationState } from '../../../types/types';
import { abbrev, formatPhoneNumber } from '../../../utils/utils';
import { withContactStyles, WrappedComponentProps } from './withContactStyles';

export const ContactInformationEmployerContent_ = ({
  classes,
  onLogClicked,
}: WrappedComponentProps) => {
  const {
    customerDetails: { employerReferences: data },
    isCommunicationAllowed,
    countryCode,
    isLegalHoldProtected
  } = useCustomerDetails();
  const {enableCountryCode} = useContext(StoreStateContext);
  const location = useLocation<CustomerLocationState>();
  const { t } = useTranslation();

  const renderTableHead = () => (
    <>
      <RACTableCell>{t('Company Name')}</RACTableCell>
      <RACTableCell>{t('Employer Phone Number')}</RACTableCell>
      <RACTableCell>{t('# Contacts Today')}</RACTableCell>
      <RACTableCell>{t('Last Call Result')}</RACTableCell>
      <RACTableCell align="center">{t('Action')}</RACTableCell>
    </>
  );

  const customerId =
    location?.state?.customer?.customerId || location?.pathname?.split('/')[3];
  const { store } = useStoreDetails();
  const storeState = store?.stateAbb?.toUpperCase();
  const countryAbb = store?.countryAbb?.toUpperCase();
  const regionCode = countryCode.filter((item)=> item.abbreviation == countryAbb)
  const MASSACHUSETTS = 'MA';
  const renderTableContent = () => (
    <>
      {data?.map((dataObj : any) => (
        <RACTableRow backgroundColor="white" key={dataObj.employerReferenceId}>
          <RACTableCell>
            <Typography variant="body2" className={classes.tableContentColor}>
              {dataObj.employerName}
            </Typography>
          </RACTableCell>
          <RACTableCell>
            <Typography variant="body2" className={classes.tableContentColor}>
              {formatPhoneNumber(
                dataObj.employerPhoneNumber,
                dataObj.doNotCall === 'Y' ||
                  isLegalHoldProtected ||
                  !isCommunicationAllowed ||
                  storeState === MASSACHUSETTS,
                  (enableCountryCode == 1 ? (dataObj.countryCode ? dataObj.countryCode :(regionCode[0]?.countryCodeValue ?? '')): '')
              )}
            </Typography>
          </RACTableCell>
          <RACTableCell>
            <Typography
              align="center"
              variant="body2"
              className={classes.tableContentColor}
            >
              {dataObj.communicationsToday}
            </Typography>
          </RACTableCell>
          <RACTableCell>
            <Typography noWrap variant="body2" color="primary">
              <RACTooltip
                title={i18n.t(dataObj.lastCallResultDescription || '')}
              >
                <span>
                  {abbrev(i18n.t(dataObj.lastCallResultDescription || ''))}
                </span>
              </RACTooltip>
            </Typography>
          </RACTableCell>
          <RACTableCell className={classes.center}>
            <RACButton
              variant="outlined"
              color="primary"
              className={classes.logButton}
              onClick={() =>
                onLogClicked(customerId, dataObj.employerPhoneNumber)
              }
              disabled={
                !dataObj?.employerPhoneNumber ||
                !isCommunicationAllowed ||
                isLegalHoldProtected ||
                dataObj.doNotCall === 'Y' ||
                storeState === MASSACHUSETTS
              }
            >
              {t('Log')}
            </RACButton>
          </RACTableCell>
        </RACTableRow>
      ))}
    </>
  );
  return (
    <RACTable
      renderTableHead={renderTableHead}
      renderTableContent={renderTableContent}
    />
  );
};

export const ContactInformationEmployerContent = (props: any) =>
  withContactStyles(props)(ContactInformationEmployerContent_);
